import { TOGGLE_SIDEBAR } from "../types";

/**
 * Action creator to toggle or set the sidebar open state
 * @param {boolean} isOpen - The sidebar open state
 * @returns {Object} The action object
 */
export const toggleSidebar = (isOpen) => {
  return {
    type: TOGGLE_SIDEBAR,
    payload: isOpen
  };
};